{
  "shell": {
    "logo_alt": "Rhemn",
    "navUpgrade": "ترقية",
    "navBilling": "الفوترة"
  },
  "upgrade": {
    "badge": "Rhemn Pro",
    "title": "علامة تبويبك. <em>ذِكرك</em>.<br />مُرتقٍ.",
    "subtitle": "كل ميزة تحتاجها ليوم أكثر قصدًا — من مواقيت الصلاة وتأمّل الآيات بالذكاء الاصطناعي إلى الطقس والمهام ذات الأولوية — في علامة تبويب واحدة هادئة وجميلة.",
    "comparison_aria": "مقارنة الخطط",
    "free": {
      "tierLabel": "الحالية",
      "tierName": "مجانية",
      "freeLabel": "مجانية دائمًا",
      "list_aria": "ميزات الخطة المجانية"
    },
    "pro": {
      "list_aria": "ميزات خطة Pro",
      "tierLabel": "الترقية إلى",
      "tierName": "Pro",
      "pricePeriod": "/ شهرياً",
      "priceAlt": "أو $39.99 / year"
    },
    "freeFeatures": {
      "clockDate": "عرض الساعة والتاريخ",
      "verseOfDay": "آية القرآن لليوم",
      "dailyBackground": "صورة خلفية يومية",
      "qiblaCompass": "بوصلة القبلة",
      "basicTasks": "مهام أساسية"
    },
    "proFeatures": {
      "weatherForecast": "توقّعات الطقس لـ 5 أيام",
      "verseFavorites": "حفظ الآيات المفضّلة وتصفّحها",
      "notesAi": "ملاحظات مع تحليل بالذكاء الاصطناعي",
      "priorityTasks": "إدارة المهام حسب الأولوية",
      "verseReflection": "تأمّل الآيات بالذكاء الاصطناعي"
    },
    "plans": {
      "monthly": {
        "label": "شهري",
        "price": "$4.99",
        "period": "/ شهرياً",
        "note": "يُحاسَب شهريًا"
      },
      "yearly": {
        "label": "سنوي",
        "price": "$39.99",
        "period": "/ سنوياً",
        "note": "شهران مجانًا",
        "badge": "وفّر ٣٣٪"
      }
    },
    "pricingTitle": "Rhemn Pro",
    "pricingDesc": "ألغِ في أي وقت. يستمر وصولك حتى نهاية فترة الفوترة دون رسوم جزئية.",
    "billingPeriod_aria": "فترة الفوترة",
    "cta": "المتابعة إلى الدفع الآمن",
    "ctaLoading": "جارٍ التحويل إلى الدفع…",
    "promoManual": "أدخل الرمز {{code}} في الصفحة التالية للحصول على الخصم.",
    "signingUpAs": "التسجيل باسم {{account}}",
    "trustSignals_aria": "إشارات الثقة",
    "reassurance": {
      "secureCheckout": "دفع آمن عبر Stripe",
      "cancelAnytime": "ألغِ في أي وقت دون أسئلة",
      "accessUntilEnd": "وصول حتى نهاية الفترة"
    },
    "errors": {
      "restoreSession": "تعذّر استعادة جلستك. يُرجى المحاولة مجددًا من الإضافة.",
      "checkoutFailed": "تعذّر بدء الدفع. يُرجى المحاولة مجددًا."
    }
  },
  "upgradeStatus": {
    "unlockedFeatures_aria": "الميزات المُفتَّحة",
    "unlockedFeatures": {
      "weatherForecast": "توقّعات الطقس لـ 5 أيام",
      "verseFavorites": "حفظ الآيات المفضّلة وتصفّحها",
      "notesAi": "ملاحظات مع تحليل بالذكاء الاصطناعي",
      "priorityTasks": "إدارة المهام حسب الأولوية",
      "verseReflection": "تأمّل الآيات بالذكاء الاصطناعي"
    },
    "success": {
      "title": "مرحبًا بك في Pro",
      "desc": "اشتراكك نشط. عُد إلى الإضافة لتجد كل ميزات Pro بانتظارك.",
      "viewBilling": "عرض تفاصيل الفوترة",
      "closeTab": "إغلاق علامة التبويب هذه"
    },
    "cancel": {
      "title": "أُلغي الدفع",
      "desc": "لا داعي للقلق — لم تتغيّر خطتك ولم تُحاسَب. يمكنك الترقية متى كنت مستعدًا.",
      "backToUpgrade": "العودة إلى الترقية",
      "returnToExtension": "العودة إلى الإضافة"
    }
  },
  "billing": {
    "title": "الفوترة",
    "subtitle": "أدِر اشتراكك واعرض سجلّ المدفوعات.",
    "subscription_aria": "حالة الاشتراك",
    "subscriptionTitle": "الاشتراك",
    "loading_aria": "جارٍ تحميل معلومات الفوترة",
    "planPro": "Rhemn Pro",
    "planFree": "Rhemn Free",
    "statusLabels": {
      "active": "نشط",
      "trialing": "فترة تجريبية مجانية",
      "past_due": "متأخّر السداد",
      "unpaid": "غير مدفوع",
      "canceled": "مُلغى",
      "incomplete": "غير مكتمل",
      "none": "لا يوجد اشتراك"
    },
    "planValues": {
      "proYearly": "Pro · سنوي",
      "proMonthly": "Pro · شهري"
    },
    "warnings": {
      "paymentFailedTitle": "فشل الدفع",
      "paymentFailedDesc": "لم تتم آخر دفعة. حدّث طريقة الدفع عبر إدارة الفوترة للحفاظ على وصول Pro.",
      "trialEndingTitle": "الفترة التجريبية تنتهي قريبًا",
      "trialEndingToday": "تنتهي فترتك التجريبية المجانية اليوم في {{date}}. أضف طريقة دفع للحفاظ على ميزات Pro.",
      "trialEndingInDays_zero": "تنتهي فترتك التجريبية المجانية خلال {{count}} يوم في {{date}}. أضف طريقة دفع للحفاظ على ميزات Pro.",
      "trialEndingInDays_one": "تنتهي فترتك التجريبية المجانية خلال يوم واحد في {{date}}. أضف طريقة دفع للحفاظ على ميزات Pro.",
      "trialEndingInDays_two": "تنتهي فترتك التجريبية المجانية خلال يومين في {{date}}. أضف طريقة دفع للحفاظ على ميزات Pro.",
      "trialEndingInDays_few": "تنتهي فترتك التجريبية المجانية خلال {{count}} أيام في {{date}}. أضف طريقة دفع للحفاظ على ميزات Pro.",
      "trialEndingInDays_many": "تنتهي فترتك التجريبية المجانية خلال {{count}} يومًا في {{date}}. أضف طريقة دفع للحفاظ على ميزات Pro.",
      "trialEndingInDays_other": "تنتهي فترتك التجريبية المجانية خلال {{count}} يوم في {{date}}. أضف طريقة دفع للحفاظ على ميزات Pro."
    },
    "cancellationScheduled": "جُدوِل الإلغاء. تحتفظ بوصول Pro الكامل حتى <strong>{{date}}</strong>.",
    "sublabel": {
      "trialEndsToday": "الفترة التجريبية تنتهي اليوم",
      "trialDaysRemaining_zero": "يتبقّى {{count}} يوم في الفترة التجريبية",
      "trialDaysRemaining_one": "يتبقّى يوم واحد في الفترة التجريبية",
      "trialDaysRemaining_two": "يتبقّى يومان في الفترة التجريبية",
      "trialDaysRemaining_few": "تتبقّى {{count}} أيام في الفترة التجريبية",
      "trialDaysRemaining_many": "يتبقّى {{count}} يومًا في الفترة التجريبية",
      "trialDaysRemaining_other": "يتبقّى {{count}} يوم في الفترة التجريبية",
      "renews": "يتجدّد في {{date}}",
      "accessUntil": "وصول حتى {{date}}"
    },
    "kv": {
      "status": "الحالة",
      "nextRenewal": "التجديد التالي",
      "trialEnds": "نهاية الفترة التجريبية",
      "trialDaysLeft_zero": "يتبقّى {{count}} يوم",
      "trialDaysLeft_one": "يتبقّى يوم واحد",
      "trialDaysLeft_two": "يتبقّى يومان",
      "trialDaysLeft_few": "تتبقّى {{count}} أيام",
      "trialDaysLeft_many": "يتبقّى {{count}} يومًا",
      "trialDaysLeft_other": "يتبقّى {{count}} يوم",
      "endsToday": "تنتهي اليوم",
      "plan": "الخطة"
    },
    "upgradeNudge": {
      "title": "افتح ميزات Pro",
      "desc": "الطقس، ومواقيت الصلاة، وتأمّل الآيات بالذكاء الاصطناعي والمزيد — $4.99/month or $39.99/year.",
      "cta": "ترقية"
    },
    "actions": {
      "manageBilling": "إدارة الفوترة وطريقة الدفع",
      "cancelConfirmTitle": "إلغاء اشتراكك؟",
      "cancelConfirmDesc": "ستحتفظ بوصول Pro الكامل حتى نهاية فترة الفوترة الحالية. لا تُصدَر مبالغ مستردّة جزئية.",
      "canceling": "جارٍ الإلغاء…",
      "yesCancel": "نعم، ألغِ",
      "keepPro": "الاحتفاظ بـ Pro",
      "cancelSubscription": "إلغاء الاشتراك"
    },
    "noSubscription": "لم يُعثر على اشتراك.",
    "paymentHistory_aria": "سجلّ المدفوعات",
    "paymentHistoryTitle": "سجلّ المدفوعات",
    "invoices_aria": "الفواتير",
    "invoiceView": "عرض",
    "invoiceView_aria": "عرض الفاتورة من {{date}}",
    "noInvoices": "لا توجد فواتير بعد.",
    "dangerZone_aria": "منطقة الخطر",
    "dangerZoneTitle": "منطقة الخطر",
    "deleteAccountTitle": "حذف الحساب",
    "deleteAccountDesc": "احذف حسابك وجميع البيانات المرتبطة به نهائيًا — المهام والملاحظات والمفضّلة وسجلّ الفوترة. لا يمكن التراجع عن هذا الإجراء.",
    "deleteAccountBtn": "حذف الحساب",
    "deleteConfirm": {
      "warning": "سيؤدّي هذا فورًا وبشكل دائم إلى:",
      "list": {
        "deleteContent": "حذف جميع مهامك وملاحظاتك والآيات المفضّلة",
        "cancelSubscription": "إلغاء أي اشتراك نشط (دون استرداد مقابل الوقت غير المستخدم)",
        "removeAccount": "إزالة حسابك من قاعدة بياناتنا",
        "signOut": "تسجيل خروجك من جميع الأجهزة"
      },
      "typeToConfirm": "اكتب <strong>DELETE</strong> للتأكيد",
      "inputPlaceholder": "DELETE",
      "deleting": "جارٍ الحذف…",
      "confirmBtn": "حذف حسابي نهائيًا",
      "cancelBtn": "إلغاء"
    },
    "errors": {
      "loadFailed": "تعذّر تحميل معلومات الفوترة.",
      "cancelFailed": "تعذّر إلغاء الاشتراك.",
      "deleteFailed": "تعذّر حذف الحساب. يُرجى المحاولة مجددًا أو التواصل مع الدعم.",
      "portalFailed": "تعذّر فتح بوابة الفوترة."
    }
  },
  "privacy": {
    "tocLabel": "سياسة الخصوصية",
    "toc_aria": "جدول المحتويات",
    "lastUpdated": "آخر تحديث<br />22 سبتمبر 2026",
    "sections": {
      "overview": "نظرة عامة",
      "informationWeCollect": "المعلومات التي نجمعها",
      "connectedServices": "الخدمات المتصلة (Google وTodoist وApple)",
      "howWeUse": "كيف نستخدم معلوماتك",
      "howWeShare": "كيف نشارك معلوماتك",
      "dataRetention": "الاحتفاظ بالبيانات",
      "yourRights": "حقوق خصوصيتك",
      "california": "سكّان كاليفورنيا (CCPA/CPRA)",
      "cookies": "ملفات تعريف الارتباط والتخزين المحلي",
      "security": "أمن البيانات",
      "changes": "التغييرات على هذه السياسة",
      "contact": "تواصل معنا"
    },
    "headings": {
      "informationWeCollect": "المعلومات التي نجمعها",
      "connectedServices": "الخدمات المتصلة (Google وTodoist وApple)",
      "howWeUse": "كيف نستخدم معلوماتك",
      "howWeShare": "كيف نشارك معلوماتك",
      "dataRetention": "الاحتفاظ بالبيانات",
      "yourRights": "حقوق خصوصيتك",
      "california": "سكّان كاليفورنيا (CCPA / CPRA)",
      "cookies": "ملفات تعريف الارتباط والتخزين المحلي",
      "security": "أمن البيانات",
      "changes": "التغييرات على هذه السياسة",
      "contact": "تواصل معنا"
    }
  },
  "deleteAccount": {
    "intro": "حذف حسابك يزيل نهائيًا:",
    "list": {
      "account": "حسابك وملفك الشخصي",
      "tasks": "جميع المهام",
      "notes": "جميع الملاحظات",
      "verses": "الآيات المحفوظة",
      "billing": "سجلات الاشتراك"
    },
    "irreversible": "لا يمكن التراجع عن هذا الإجراء.",
    "appleNotice": "حذف حسابك لا يلغي اشتراكًا تم شراؤه عبر App Store. يُرجى إلغاؤه أيضًا من الإعدادات ← Apple ID ← الاشتراكات.",
    "manageSubscription": "إدارة الاشتراك",
    "continueBtn": "متابعة الحذف",
    "keepBtn": "الاحتفاظ بحسابي",
    "confirmTitle": "حذف حسابك؟",
    "confirmDesc": "سيتم حذف حسابك وجميع بياناته نهائيًا. لا يمكن التراجع عن هذا الإجراء.",
    "confirmBtn": "حذف حسابي نهائيًا",
    "deleting": "جارٍ الحذف…",
    "error": "تعذّر حذف حسابك. يُرجى التحقق من اتصالك والمحاولة مرة أخرى."
  }
}
